module.exports = __webpack_public_path__ + "img/banner4.d8b27cc2.png";